// src/i18n.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: {
    message: {
      hello: 'Hello world',
      welcome: 'Welcome {name}',
      Home: 'Home',
      Search: 'Search',
      About: 'About',
      Learn: 'Learn',
      Contact: 'Contact'
    }
  }
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n